
// src/reducers/groups-reducer.js

import { mergeArray, deleteArray, updateArray, sortArray, getArray } from '../helpers/store'

import {
  FETCH_GROUPS,
  FETCH_GROUPS_REQUESTED,
  FETCH_GROUPS_COMPLETED,
  FETCH_GROUPS_FAILED,
  FETCH_GROUP_UNREAD_COUNT,
  FETCH_GROUP_UNREAD_COUNT_REQUESTED,
  FETCH_GROUP_UNREAD_COUNT_COMPLETED,
  FETCH_GROUP_UNREAD_COUNT_FAILED,
  FETCH_ALL_UNREAD_COUNT,
  FETCH_ALL_UNREAD_COUNT_REQUESTED,
  FETCH_ALL_UNREAD_COUNT_COMPLETED,
  FETCH_ALL_UNREAD_COUNT_FAILED,
  FETCH_GROUP,
  FETCH_GROUP_REQUESTED,
  FETCH_GROUP_COMPLETED,
  FETCH_GROUP_FAILED,
  CREATE_GROUP,
  CREATE_GROUP_REQUESTED,
  CREATE_GROUP_COMPLETED,
  CREATE_GROUP_FAILED,
  UPDATE_GROUP,
  UPDATE_GROUP_REQUESTED,
  UPDATE_GROUP_COMPLETED,
  UPDATE_GROUP_FAILED,
  UPDATE_GROUP_MEMBERSHIP,
  UPDATE_GROUP_MEMBERSHIP_REQUESTED,
  UPDATE_GROUP_MEMBERSHIP_COMPLETED,
  UPDATE_GROUP_MEMBERSHIP_FAILED,
  SORT_GROUP_MEMBERS,
  SORT_GROUP_MEMBERS_REQUESTED,
  SORT_GROUP_MEMBERS_COMPLETED,
  SORT_GROUP_MEMBERS_FAILED,
  SORT_GROUPS,
  SORT_GROUPS_REQUESTED,
  SORT_GROUPS_COMPLETED,
  SORT_GROUPS_FAILED,
  MERGE_GROUP,
  MERGE_GROUP_REQUESTED,
  MERGE_GROUP_COMPLETED,
  MERGE_GROUP_FAILED,
  DELETE_GROUP,
  DELETE_GROUP_REQUESTED,
  DELETE_GROUP_COMPLETED,
  DELETE_GROUP_FAILED,
  FETCH_REMIND_MAIL_SETTINGS,
  FETCH_REMIND_MAIL_SETTINGS_REQUESTED,
  FETCH_REMIND_MAIL_SETTINGS_COMPLETED,
  FETCH_REMIND_MAIL_SETTINGS_FAILED,
  UPDATE_REMIND_MAIL_SETTING,
  UPDATE_REMIND_MAIL_SETTING_REQUESTED,
  UPDATE_REMIND_MAIL_SETTING_COMPLETED,
  UPDATE_REMIND_MAIL_SETTING_FAILED,
  UPDATE_REMIND_MAIL_SCHEDULE,
  UPDATE_REMIND_MAIL_SCHEDULE_REQUESTED,
  UPDATE_REMIND_MAIL_SCHEDULE_COMPLETED,
  UPDATE_REMIND_MAIL_SCHEDULE_FAILED,
  SEARCH_GROUPS,
  LOAD_GROUP,
  LOAD_GROUP_UNREAD_COUNT,
  FETCH_ALBUM_GROUP_IMAGE,
  FETCH_ALBUM_GROUP_IMAGE_REQUESTED,
  FETCH_ALBUM_GROUP_IMAGE_COMPLETED,
  FETCH_ALBUM_GROUP_IMAGE_FAILED,
  FETCH_ALBUM_GROUP_FILE,
  FETCH_ALBUM_GROUP_FILE_REQUESTED,
  FETCH_ALBUM_GROUP_FILE_COMPLETED,
  FETCH_ALBUM_GROUP_FILE_FAILED,
  FETCH_ALBUM_GROUP_VIDEO,
  FETCH_ALBUM_GROUP_VIDEO_REQUESTED,
  FETCH_ALBUM_GROUP_VIDEO_COMPLETED,
  FETCH_ALBUM_GROUP_VIDEO_FAILED,
  CLEAR_GROUP_ALBUM,
  FETCH_ALBUM_LENGTH,
  FETCH_SCHEDULED_SETTINGS,
  FETCH_SCHEDULED_SETTINGS_REQUESTED,
  FETCH_SCHEDULED_SETTINGS_COMPLETED,
  FETCH_SCHEDULED_SETTINGS_FAILED,
  CLEAR_SCHEDULED_SETTINGS,
  UPDATE_SCHEDULED_SETTINGS,
  UPDATE_SCHEDULED_SETTINGS_REQUESTED,
  UPDATE_SCHEDULED_SETTINGS_COMPLETED,
  UPDATE_SCHEDULED_SETTINGS_FAILED,
} from '../actions/groups'
import {
  UPDATE_USER_PROFILE_COMPLETED
} from '../actions/user'

import {
  FETCH_FAVORITE_GROUPS_COMPLETED,
  UPDATE_FAVORITE_GROUP_COMPLETED,
} from '../actions/favorite'

import {
  LOGOUT_COMPLETED,
} from '../actions/sessions'

import {
  FLUSH_UNREAD_DIARIES_COMPLETED,
} from '../actions/diaries'

import map from 'lodash/map'
import find from 'lodash/find'
import isEqual from 'lodash/isEqual'
import each from 'lodash/each'
import actions from '../actions'

const initialState = {
  isFetching: false,
  isFetchFailed: false,
  isFetchingGroup: false,
  isFetchGroupFailed: false,
  isRequesting: false,
  isRequestFailed: false,
  isUpdating: false,
  isUpdateFailed: false,
  isMembershipUpdating: false,
  isMembershipUpdateFailed: false,
  isRemindSettingUpdating: false,
  isRemindSettingUpdateFailed: false,
  items: undefined,
  imageItems: undefined,
  fileItems: undefined,
  videoItems: undefined,
  created: undefined,
  hasMoreImage: true,
  hasMoreFile: true,
  hasMoreVideo: true,
  remindSchedule: undefined,
  created: undefined,
  scheduled_settings: undefined,
  isScheduledSettingsFetching: false,
  isScheduledSettingsFailed: false,
  isUpdateScheduledSettingsFetching: false,
  isUpdateScheduledSettingsFailed: false,
}

export default function groupsReducer(state = initialState, action = {}) {
  let items, group, old_group

  switch(action.type) {
  case FETCH_GROUPS_REQUESTED:
  case SORT_GROUPS_REQUESTED:
    return Object.assign({}, state, {
      isFetching: true,
      isFetchFailed: false,
      isFetchGroupFailed: false,
    })

  case FETCH_ALBUM_GROUP_IMAGE_REQUESTED:
  case FETCH_ALBUM_GROUP_FILE_REQUESTED:
  case FETCH_ALBUM_GROUP_VIDEO_REQUESTED:
    return Object.assign({}, state, {
      isFetching: true,
      isFetchFailed: false,
    })

  case FETCH_GROUP_REQUESTED:
    return Object.assign({}, state, {
      isFetchingGroup: true,
      isFetchGroupFailed: false,
    })

  case FETCH_GROUP_UNREAD_COUNT_REQUESTED:
  case FETCH_ALL_UNREAD_COUNT_REQUESTED:
  case DELETE_GROUP_REQUESTED:
  case MERGE_GROUP_REQUESTED:
    return Object.assign({}, state, {
      isRequesting: true,
      isRequestFailed: false,
    })

  case LOGOUT_COMPLETED:
    return Object.assign({}, state, {
      items: undefined,
    })

  case CREATE_GROUP_REQUESTED:
  case UPDATE_GROUP_REQUESTED:
    return Object.assign({}, state, {
      isUpdating: true,
      isUpdateFailed: false,
    })

  case UPDATE_GROUP_MEMBERSHIP_REQUESTED:
  case SORT_GROUP_MEMBERS_REQUESTED:
    return Object.assign({}, state, {
      isMembershipUpdating: true,
      isMembershipUpdateFailed: false,
    })

  case UPDATE_REMIND_MAIL_SETTING_REQUESTED:
  case UPDATE_REMIND_MAIL_SCHEDULE_REQUESTED:
    return Object.assign({}, state, {
      isRemindSettingUpdating: true,
      isRemindSettingUpdateFailed: false,
    })

  case FETCH_REMIND_MAIL_SETTINGS_REQUESTED:
    return Object.assign({}, state, {
      remindSchedule: undefined,
      isRequesting: true,
      isRequestFailed: false,
    })

  case FETCH_GROUPS_FAILED:
  case SORT_GROUPS_FAILED:
  case FETCH_ALBUM_GROUP_IMAGE_FAILED:
  case FETCH_ALBUM_GROUP_FILE_FAILED:
  case FETCH_ALBUM_GROUP_VIDEO_FAILED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: true,
    })

  case FETCH_GROUP_FAILED:
    return Object.assign({}, state, {
      isFetchingGroup: false,
      isFetchGroupFailed: true,
    })

  case FETCH_GROUP_UNREAD_COUNT_FAILED:
  case FETCH_ALL_UNREAD_COUNT_FAILED:
  case MERGE_GROUP_FAILED:
  case DELETE_GROUP_FAILED:
    return Object.assign({}, state, {
      isRequesting: false,
      isRequestFailed: true,
    })

  case CREATE_GROUP_FAILED:
  case UPDATE_GROUP_FAILED:
    return Object.assign({}, state, {
      isUpdating: false,
      isUpdateFailed: true,
    })

  case UPDATE_GROUP_MEMBERSHIP_FAILED:
  case SORT_GROUP_MEMBERS_FAILED:
    return Object.assign({}, state, {
      isMembershipUpdating: false,
      isMembershipUpdateFailed: true,
    })

  case FETCH_REMIND_MAIL_SETTINGS_FAILED:
    return Object.assign({}, state, {
      isRequesting: false,
      isRequestFailed: true,
    })

  case UPDATE_REMIND_MAIL_SETTING_FAILED:
  case UPDATE_REMIND_MAIL_SCHEDULE_FAILED:
    return Object.assign({}, state, {
      isRemindSettingUpdating: false,
      isRemindSettingUpdateFailed: true,
    })

  case FETCH_GROUPS_COMPLETED:
  case SORT_GROUPS_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      items: !state.items ? action.results : map(action.results, (result)=> {
        const group = find(state.items, (item)=> item.group_id == result.group_id)
        if (!group) return result   // itemsに含まれていない新たなgroupが帰ってきた場合
        else if (isEqual(group, result)) return group  // itemsに入っているgroupの内容と同一内容だった場合
        else return Object.assign({}, group, result)  // itemsに入っているgroupの内容と異なる場合
      }),
    })

  case FETCH_ALBUM_GROUP_IMAGE_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      hasMoreImage: action.results.files.length == FETCH_ALBUM_LENGTH,
      imageItems: action.offset > 0 ? mergeArray('file_id', state.imageItems, action.results.files) : action.results.files,
    })

  case FETCH_ALBUM_GROUP_FILE_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      hasMoreFile: action.results.files.length == FETCH_ALBUM_LENGTH,
      fileItems: action.offset > 0 ? mergeArray('file_id', state.fileItems, action.results.files) : action.results.files,
    })

  case FETCH_ALBUM_GROUP_VIDEO_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      hasMoreVideo: action.results.files.length == FETCH_ALBUM_LENGTH,
      videoItems: action.offset > 0 ? mergeArray('video_id', state.videoItems, action.results.files) : action.results.files,
    })

  case CLEAR_GROUP_ALBUM:
    return Object.assign({}, state, {
      isFetching: false,
      imageItems: undefined,
      fileItems: undefined,
      videoItems: undefined,
    })

  case FETCH_GROUP_UNREAD_COUNT_COMPLETED:
    return Object.assign({}, state, {
      isRequesting: false,
      isRequestFailed: false,
      items: updateArray('group_id', state.items, action.results.group_id, 'unreadCount', action.results.unreads)
    })

  case LOAD_GROUP_UNREAD_COUNT:
    items = updateArray('group_id', state.items, action.group_id, 'unreadCount', action.unreads)
    if (state.items !== items)
      return Object.assign({}, state, { items })
    else
      return state

  case FLUSH_UNREAD_DIARIES_COMPLETED:
    return Object.assign({}, state, {
      items: updateArray('group_id', state.items, action.group_id, 'unreadCount', 0)
    })

  case FETCH_ALL_UNREAD_COUNT_COMPLETED:
    items = state.items
    each(action.results, (item)=> {
      items = updateArray('group_id', items, item.group_id, 'unreadCount', item.unreads)
    })
    return Object.assign({}, state, {
      isRequesting: false,
      isRequestFailed: false,
      items: items,
    })

  case FETCH_GROUP_COMPLETED:
    old_group = getArray('group_id', state.items, action.results.group_id)
    group = old_group ? Object.assign({}, action.results, { unreadCount: old_group.unreadCount }) : action.results
    if (isEqual(group, old_group))
      group = old_group

    return Object.assign({}, state, {
      isFetchingGroup: false,
      isFetchGroupFailed: false,
      items: mergeArray('group_id', state.items, [group]),
    })

  case CREATE_GROUP_COMPLETED:
    return Object.assign({}, state, {
      isUpdating: false,
      isUpdateFailed: false,
      items: mergeArray('group_id', state.items, [action.results]),
      created: action.results,
    })

  case UPDATE_GROUP_COMPLETED:
    const results = Object.assign({}, action.results, {
      icon_image: {
        url: action.results.icon_image.url + `?refresh=${Math.random()}`,
        thumb_url: action.results.icon_image.thumb_url + `?refresh=${Math.random()}`,
      }
    })
    return Object.assign({}, state, {
      isUpdating: false,
      isUpdateFailed: false,
      items: mergeArray('group_id', state.items, [results]),
    })

  case UPDATE_GROUP_MEMBERSHIP_COMPLETED:
    return Object.assign({}, state, {
      isMembershipUpdating: false,
      isMembershipUpdateFailed: false,
      items: mergeArray('group_id', state.items, [action.results]),
    })

  case SORT_GROUP_MEMBERS_COMPLETED:
    return Object.assign({}, state, {
      isMembershipUpdating: false,
      isMembershipUpdateFailed: false,
      items: mergeArray('group_id', state.items, [action.results]),
    })

  case DELETE_GROUP_COMPLETED:
    return Object.assign({}, state, {
      isRequesting: false,
      isRequestFailed: false,
      items: deleteArray('group_id', state.items, action.results.group_id)
    })

  case MERGE_GROUP_COMPLETED:
    return Object.assign({}, state, {
      isRequesting: false,
      isRequestFailed: false,
      items: deleteArray('group_id', state.items, action.results.group_id)
    })

  case FETCH_REMIND_MAIL_SETTINGS_COMPLETED:
    return Object.assign({}, state, {
      isRequesting: false,
      isRequestFailed: false,
      remindSchedule: action.results,
    })

  case UPDATE_REMIND_MAIL_SETTING_COMPLETED:
    return Object.assign({}, state, {
      isRemindSettingUpdating: false,
      isRemindSettingUpdateFailed: false,
      items: mergeArray('group_id', state.items, [action.results]),
    })

  case UPDATE_REMIND_MAIL_SCHEDULE_COMPLETED:
    return Object.assign({}, state, {
      isRemindSettingUpdating: false,
      isRemindSettingUpdateFailed: false,
      remindSchedule: action.results
    })

  case FETCH_FAVORITE_GROUPS_COMPLETED:
  case UPDATE_FAVORITE_GROUP_COMPLETED:
    items = state.items.map((item)=> {
      const __item = find(action.results, (_item)=> _item.group_id == item.group_id)
      return Object.assign({}, item, {
        favorite: !!(__item && __item.favorite)
      })
    })
    return Object.assign({}, state, {
      items: items
    })

  case SEARCH_GROUPS:
    return Object.assign({}, state, {
      search: action.query
    })

  case LOAD_GROUP:
    if (action.deleted || !action.group.can_read)
      return Object.assign({}, state, {
        items: deleteArray('group_id', state.items, action.group.group_id),
      })

    old_group = getArray('group_id', state.items, action.group.group_id)
    group = old_group ? Object.assign({}, action.group, { unreadCount: old_group.unreadCount }) : action.group

    return Object.assign({}, state, {
      items: mergeArray('group_id', state.items, [group]),
    })

  case UPDATE_USER_PROFILE_COMPLETED:
    const user = action.results
    items = map(state.items, (group)=> {
      const members = map(group.members, (member)=> member.user_id == user.user_id ? user : member)
      return Object.assign({}, group, { members })
    })
    return Object.assign({}, state, { items })

  case FETCH_SCHEDULED_SETTINGS_REQUESTED:
    return Object.assign({}, state, {
      isScheduledSettingsFetching: true,
      isScheduledSettingsFailed: false,
    })

  case UPDATE_SCHEDULED_SETTINGS_REQUESTED:
    return Object.assign({}, state, {
      isUpdateScheduledSettingsFetching: true,
      isUpdateScheduledSettingsFailed: false,
    })

  case FETCH_SCHEDULED_SETTINGS_FAILED:
    return Object.assign({}, state, {
      isScheduledSettingsFetching: false,
      isScheduledSettingsFailed: true,
    })

  case UPDATE_SCHEDULED_SETTINGS_FAILED:
    return Object.assign({}, state, {
      isUpdateScheduledSettingsFetching: false,
      isUpdateScheduledSettingsFailed: true,
    })

  case FETCH_SCHEDULED_SETTINGS_COMPLETED:
    return Object.assign({}, state, {
      isScheduledSettingsFetching: false,
      isScheduledSettingsFailed: false,
      scheduled_settings: action.results.group_membership,
    })

  case UPDATE_SCHEDULED_SETTINGS_COMPLETED:
    return Object.assign({}, state, {
      isUpdateScheduledSettingsFetching: false,
      isUpdateScheduledSettingsFailed: false,
    })

  case CLEAR_SCHEDULED_SETTINGS:
    return Object.assign({}, state, {
      scheduled_settings: undefined,
    })
 
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/groups-reducer.js